import { buildImgixUrl } from "@/lib";
import { FileUpload } from "@/storybook-components";
import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { FileQuestionProps } from "../types";

export const FileQuestion = (props: FileQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    size,
    answerAriaLabel,
    loadingText,
    deleteText,
    replaceText,
    uploadButtonText,
    isDisabled,
    handleFileUpload,
    onDelete,
    isDeleteDisabled,
    isReplaceDisabled,
    answerProps,
    contentClassName,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    questionId,
    className,
    layoutProps,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <FileUpload
          id={questionId}
          className={contentClassName}
          isDisabled={isDisabled}
          onUpload={handleFileUpload}
          onDelete={onDelete}
          isDeleteDisabled={isDeleteDisabled}
          isReplaceDisabled={isReplaceDisabled}
          fileSrc={buildImgixUrl(answer?.value)}
          fileName={answer?.file_name}
          loadingText={loadingText}
          fileContentType={answer?.file_content_type}
          aria-label={answerAriaLabel}
          deleteText={deleteText}
          replaceText={replaceText}
          size={size}
          {...answerProps}
        >
          {uploadButtonText}
        </FileUpload>
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
